/* ============================================================
   Maui Craft Creations — Scroll Animation Engine
   Uses Intersection Observer API for performance
   ============================================================ */

(function() {
  'use strict';

  // Configuration
  const CONFIG = {
    threshold: 0.15,
    rootMargin: '0px 0px -80px 0px'
  };

  // Initialize scroll animations
  function initScrollAnimations() {
    // Create intersection observer
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Remove the initial animation class and add visible class to trigger animation
          entry.target.classList.add('animate-visible');
          // Stop observing after animation is triggered
          observer.unobserve(entry.target);
        }
      });
    }, CONFIG);

    // Target elements with scroll animation classes
    const targets = document.querySelectorAll(
      '.scroll-fade, ' +
      '.scroll-slide-up, ' +
      '.scroll-slide-left, ' +
      '.scroll-slide-right, ' +
      '.scroll-scale'
    );

    targets.forEach((el) => {
      // Initialize by removing animation and storing the animation class
      el.style.opacity = '0';
      if (el.classList.contains('scroll-slide-up')) {
        el.style.transform = 'translateY(24px)';
      } else if (el.classList.contains('scroll-slide-left')) {
        el.style.transform = 'translateX(-24px)';
      } else if (el.classList.contains('scroll-slide-right')) {
        el.style.transform = 'translateX(24px)';
      } else if (el.classList.contains('scroll-scale')) {
        el.style.transform = 'scale(0.92)';
      }
      observer.observe(el);
    });
  }

  // Stagger animations for lists
  function initStaggerAnimations() {
    const lists = document.querySelectorAll('[data-stagger]');
    lists.forEach((list) => {
      const children = list.querySelectorAll('[data-stagger-child]');
      children.forEach((child, index) => {
        child.style.animationDelay = `${index * 0.1}s`;
        child.classList.add('scroll-slide-up');
      });
    });
  }

  // Parallax scroll effect for hero sections
  function initParallax() {
    const parallaxElements = document.querySelectorAll('[data-parallax]');

    if (parallaxElements.length === 0) return;

    let ticking = false;

    function update() {
      parallaxElements.forEach((el) => {
        const rect = el.getBoundingClientRect();
        const offset = (window.innerHeight - rect.top) * 0.15;
        el.style.transform = `translateY(${offset}px)`;
      });
      ticking = false;
    }

    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
  }

  // Enhance button interactions
  function initButtonEnhancements() {
    const buttons = document.querySelectorAll('.mcc-btn, button:not(.mcc-burger)');

    buttons.forEach((btn) => {
      btn.addEventListener('mouseenter', function() {
        this.style.willChange = 'transform';
      });

      btn.addEventListener('mouseleave', function() {
        this.style.willChange = 'auto';
      });

      // Ripple effect on click
      btn.addEventListener('click', function(e) {
        const rect = this.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        const ripple = document.createElement('span');
        ripple.style.left = x + 'px';
        ripple.style.top = y + 'px';
        ripple.style.position = 'absolute';
        ripple.style.width = '20px';
        ripple.style.height = '20px';
        ripple.style.borderRadius = '50%';
        ripple.style.background = 'rgba(255, 255, 255, 0.6)';
        ripple.style.pointerEvents = 'none';
        ripple.style.animation = 'ripple-animation 0.6s ease-out';

        this.style.position = 'relative';
        this.style.overflow = 'hidden';
        this.appendChild(ripple);

        setTimeout(() => ripple.remove(), 600);
      });
    });
  }

  // Smooth link navigation
  function initSmoothLinks() {
    document.querySelectorAll('a[href^="#"]').forEach((link) => {
      link.addEventListener('click', function(e) {
        const href = this.getAttribute('href');
        if (href === '#') return;

        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  // Add animation visibility class support
  function initAnimationClasses() {
    const style = document.createElement('style');
    style.textContent = `
      @keyframes ripple-animation {
        to {
          transform: scale(4);
          opacity: 0;
        }
      }

      .animate-visible {
        animation: none !important;
        opacity: 1 !important;
        transform: none !important;
      }
    `;
    document.head.appendChild(style);
  }

  // Initialize on DOM ready
  function init() {
    initAnimationClasses();
    initScrollAnimations();
    initStaggerAnimations();
    initParallax();
    initButtonEnhancements();
    initSmoothLinks();
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize after dynamic content loads (for AJAX/SPAs)
  window.reinitScrollAnimations = function() {
    initScrollAnimations();
    initStaggerAnimations();
  };
})();
